import { render } from "./UnderConstructionView.vue?vue&type=template&id=66fd9d79"
import script from "./UnderConstructionView.vue?vue&type=script&lang=js"
export * from "./UnderConstructionView.vue?vue&type=script&lang=js"

import "./UnderConstructionView.vue?vue&type=style&index=0&id=66fd9d79&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__